import React from "react";
import styles from "./Stack.module.css";

const gapClassMap = {
  "1": styles.gap1,
  "2": styles.gap2,
  "3": styles.gap3,
  "4": styles.gap4,
  "5": styles.gap5,
  "6": styles.gap6,
};

const alignClassMap = {
  stretch: styles.alignStretch,
  start: styles.alignStart,
  center: styles.alignCenter,
};

export default function Stack({
  children,
  gap = "4",
  align = "stretch",
  className = "",
}) {
  return (
    <div
      className={[
        styles.stack,
        gapClassMap[gap],
        alignClassMap[align] || styles.alignStretch,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={!gapClassMap[gap] ? { gap } : undefined}
    >
      {children}
    </div>
  );
}